export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10804.cd5fddc4.jpg";